// Aktualna wersja polityki prywatności — musi odpowiadać wersji
// zapisywanej w triggerze handle_new_user oraz dacie na stronie /polityka-prywatnosci.
export const CURRENT_PRIVACY_POLICY_VERSION = "2026-09-09";
